// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"baada9fe","239":"fabbb994","455":"d71f09f3"}[chunkId] + ".chunk.js";
};